module.exports = __webpack_public_path__ + "76dfe2cdd867bd4c236215ef14e1170f.svg";